const CUSTOM_DATES_INDEX = -1;

export default CUSTOM_DATES_INDEX;
